import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    FlatList,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacity,
    KeyboardAvoidingView,
    ImageBackground,
    ActivityIndicator, RefreshControl,
    Text,
    I18nManager
} from "react-native";
import {connect} from "react-redux";

import {scale, moderateScale, verticalScale} from '../../../tools/Scaling';
import Colors from "../../../tools/Colors";
import HMActionBar from "../../../customviews/HMActionBar";
import {AsyngStorageClass} from "../../../tools/AsyngStorageClass";
import {
    callWebservice as callWebserviceSplash,
    serviceActionSetState
} from "../splash/action/ActionSplashGetAllData";

const {width: SCREEN_WIDTH} = Dimensions.get("window");
const SLIDER_HEIGHT = verticalScale(180);
const HEADER_HEIGHT = Platform.OS === "ios" ? verticalScale(64) : verticalScale(50);
const SCROLL_HEIGHT = SLIDER_HEIGHT - HEADER_HEIGHT;
const THEME_COLOR = Colors.colorPrimary;
import i18n from '../../../I18n/i18n.js';
import HMListDiffSize from "../../../customviews/HMListDiffSize";

import styles from "../../../styles/index.style";

import {itemWidth, sliderWidth} from "../../../styles/SliderEntry.style";

const IS_ANDROID = Platform.OS === 'android';
const SLIDER_1_FIRST_ITEM = 0;
let content = null
// import {DialogUpdateAppCustomize} from "../../../customviews/DialogUpdateAppCustomize";
import moment from "moment-jalaali";
import store from "../../../redux/store";
import {typeExport} from "../../../redux/store/type";
import HMTextView from "../../../customviews/HMTextView";
import HMImageView from "../../../customviews/HMImageView";
import * as  NavigationService from "../../../redux/NavigationService";

import HMSwiper from "../../../customviews/swiper/HMSwiper";
import {DialogUpdateAppCustomize} from "../../../customviews/dialogUpdateApp/DialogUpdateAppCustomize";
import {Tools} from "../../../tools/Tools";

moment.locale("fa");
moment.loadPersian();

class MainScreen extends Component {

    wp(percentage, viewportWidth) {
        const value = (percentage * viewportWidth) / 100;
        return Math.round(value);
    }

    constructor(props) {
        super(props);

        let sliderWidth = 1;
        let itemWidth = 1;
        let slideHeight = 1;
        let widthOriginal = Platform.OS === "web" ? 1 : typeExport._WIDTH;

        if (Platform.OS === "web") {
            let viewportWidth = document.body.clientWidth;
            let viewportHeight = document.body.clientHeight;
            widthOriginal = document.body.clientWidth;

            slideHeight = viewportHeight * 0.35;
            const slideWidth = this.wp(75, viewportWidth);
            const itemHorizontalMargin = this.wp(2, viewportWidth);

            sliderWidth = viewportWidth;
            itemWidth = (slideWidth + itemHorizontalMargin * 2) + 55;
        }
        this.state = {
            widthOriginal: widthOriginal,

            itemWidth: itemWidth,
            sliderWidth: sliderWidth,
            slideHeight: slideHeight,


            /*        itemWidth: 1,
                    sliderWidth: 1,
                    slideHeight: 1,*/
            slider1ActiveSlide: SLIDER_1_FIRST_ITEM,

            modalHeight: 0,
            ddd: [
                "The min size must be a number.",
                "The min size must be less than 4.",
                "The max size must be a number."
            ],

            //   entries: props.DataSplashScreen.results.slider

        };
        content = this;
    }


    componentWillReceiveProps(props) {

    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }

    componentDidMount() {

        let {DataSplashScreen} = this.props;
        if (DataSplashScreen.STATE && DataSplashScreen.STATE.type) {
            setTimeout(function () {
                NavigationService.navigateParams(DataSplashScreen.STATE.type, {item: DataSplashScreen.STATE.item});
                store.dispatch(serviceActionSetState(null));
                // alert("df")
            }, 10)
            // NavigationService.navigateParams(DataSplashScreen.STATE.type);
            // NavigationService.navigateParams(DataSplashScreen.STATE.type, {item: DataSplashScreen.STATE.item});
        }
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;

                function wp(percentage) {
                    const value = (percentage * viewportWidth) / 100;
                    return Math.round(value);
                }

                const slideHeight = viewportHeight * 0.35;
                const slideWidth = wp(75);
                const itemHorizontalMargin = wp(2);

                const sliderWidth = viewportWidth;
                const itemWidth = (slideWidth + itemHorizontalMargin * 2) + 55;

                content.setState({
                        widthOriginal: document.body.clientWidth,
                        widthV: document.body.clientWidth > 600 ? document.body.clientWidth / 2.05 : document.body.clientWidth,

                        //    widthV: document.body.clientWidth,
                        heightV: document.body.clientHeight,
                        itemWidth: itemWidth,
                        sliderWidth: sliderWidth,
                        slideHeight: slideHeight,
                    },
                )


            })
        //     if ((global._loadDataCount && global._loadDataCount > 0) || !(this.props.DataSplashScreen.results))
        this.getDataServerSplash();
        // else
        //     global._loadDataCount = global._loadDataCount ? global._loadDataCount + 1 : 1;
    }

    async getDataServerSplash() {

        let dataSplash = this.props.DataSplashScreen;
        if (dataSplash.TypeLogin == 2 || dataSplash.TypeLogin == 1 || dataSplash.TypeLogin == null) {
            let paramss = {
                "token": dataSplash.token,
                'token_mahale': dataSplash.tokenMahaleh,
                'tokenLaravel': dataSplash.tokenLaravel,
                "id": 1,
                "lang": i18n.locale,
                'City': dataSplash.City,
                "imei": 0,
                "token_fb": dataSplash.token_fb,
            };
            if (dataSplash.Connection) {

                if (global.GoOfflineToMain || !(this.props.DataSplashScreen.results))

                    if ((global._loadDataCount && global._loadDataCount > 0) || (global.GoOfflineToMain || !(dataSplash.TypeLogin == 2 ? dataSplash.resultsShahrdar : dataSplash.results))) {
                        if (dataSplash.TypeLogin == 2)
                            store.dispatch(callWebserviceSplash(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))
                        else {
                            store.dispatch(callWebserviceSplash(typeExport.urlGetAllDataSaina, paramss, typeExport.TypeGetAllDataSaina, typeExport._GET, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))

                        }
                        //  this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, token, token_fb, imageBack);

                    }
                    else
                        global._loadDataCount = global._loadDataCount ? global._loadDataCount + 1 : 1;


                await AsyngStorageClass.setAsyng("splash" + global.IdCity, dataSplash.results);

                if (dataSplash.TypeLogin == 2)
                    await AsyngStorageClass.setAsyng("splashShahrdar" + global.IdCity, dataSplash.resultsShahrdar);
                else
                    await AsyngStorageClass.setAsyng("splashSaina" + global.IdCity, dataSplash.resultsSaina);

            }
            else {
                if (dataSplash.TypeLogin == 2)
                    store.dispatch(callWebserviceSplash(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeGetAllDataShardar, typeExport._POST, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))
                else {
                    store.dispatch(callWebserviceSplash(typeExport.urlGetAllDataSaina, paramss, typeExport.TypeGetAllDataSaina, typeExport._GET, dataSplash.token, dataSplash.token_fb, null, "MainScreen"))

                }
            }
        }

    }

    componentWillUnmount() {
        //Tools._RemoveConnectivity()
    }

    /*  static ShowMessageBack(text) {
          content.refs.toast.show(text ? text : i18n.t('constant.DescExit'), 1200, () => {
              // something you want to do at close
          });
      }
  */
    render() {
        const {slider1ActiveSlide} = this.state;
        // this.state.dataSource = this.props.data.results.slider;

        //  let {results} = this.props.DataSplashScreen;
        let {results, City} = store.getState().reducerSplashGetAllData;

        //
        // let mB = moment("1399/05/20", 'jYYYY/jM/jD');
        // let mE = moment("1399/05/20", 'jYYYY/jM/jD');
        // //let m = "1399/05/20";
        // let beginDate = mB.subtract(1, 'month').locale('fa').format('jYYYY/jM/jD');
        // let endDate = mE.add(1, 'month').locale('fa').format('jYYYY/jM/jD');
        // // let endDate = "1399/05/28";
        //
        // if ((typeExport._NameApp === "Cloud"|| typeExport._NameApp === "CloudTest") && Tools.CheckValue(City))
        //     typeExport._NameCity = City?.name;
        return (
            <View style={{position: 'relative', flex: 1}}>

                {/*       <HMImageBackground/>*/}

                <KeyboardAvoidingView style={{width: "100%", height: "100%",}} behavior={"padding"}
                                      enabled={Platform.OS === "ios"}>
                    <HMActionBar
                        profile
                        menu
                        props={this.props} statusBarTransparent
                       // text={(typeExport._NameApp === "Cloud"|| typeExport._NameApp === "CloudTest") ? typeExport._NameCity + " من ": i18n.t('appName') }
                        text={ i18n.t('appName') }
                        //  text={i18n.t('constant.Information')}

                        headerVisibility more_menu
                        onBackPress={() => this.props.navigation.pop()}

                    />
                    {/*<DatePicker*/}
                    {/*mode={"calendar"}*/}
                    {/*isGregorian={false}*/}
                    {/*options={{*/}
                    {/*defaultFont: typeExport.regularFontName,*/}
                    {/*headerFont: typeExport.regularFontName,*/}
                    {/*}}*/}
                    {/*// selected={getFormatedDate("1399-09-20", 'jYYYY/jMM/jDD')}*/}
                    {/*current={"1399/05/20"}*/}
                    {/*selected={"1399/05/20"}*/}
                    {/*minimumDate={beginDate}*/}
                    {/*maximumDate={endDate}*/}
                    {/*selectorStartingYear={1398}*/}
                    {/*arraySelect={[*/}
                    {/*{name: "1399/05/18"},*/}
                    {/*{name: "1399/05/19"},*/}
                    {/*{name: "1399/05/20"},*/}
                    {/*{name: "1399/05/21"},*/}
                    {/*{name: "1399/05/22"},*/}
                    {/*]}*/}

                    {/*/>*/}
                    {
                        !this.props.DataSplashScreen.isLoadingBackground && (!this.props.DataSplashScreen.NoInternetDialogBackground) ?
                            null
                            :
                            <View
                                style={{
                                    width: "100%",
                                    //  flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: this.props.DataSplashScreen.NoInternetDialogBackground ? Colors.red : Colors.white,
                                    alignSelf: 'center',
                                    padding: moderateScale(6)
                                }}
                            >
                                {this.props.DataSplashScreen.NoInternetDialogBackground ?
                                    <View
                                        style={{
                                            width: "100%",
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',

                                        }}>


                                        <HMTextView
                                            type={"bold"}

                                            style={[
                                                {
                                                    // position: 'absolute',
                                                    //  bottom: 0,
                                                    // height: moderateScale(44),
                                                    // width: '100%',
                                                    textAlign: "center",
                                                    color: Colors.white,
                                                    fontSize: moderateScale(11),
                                                    //  padding: moderateScale(1),

                                                    // backgroundColor: 'rgba(0,0,0,0.25)',
                                                }]}
                                            numberOfLines={2}
                                            text={"خطایی رخ داده مجددا تلاش نمایید"}
                                        />
                                        <View style={{width: moderateScale(4)}}/>
                                        <TouchableOpacity
                                            onPress={() => {
                                                this.getDataServerSplash()

                                            }}
                                            style={{
                                                // flex: .33,
                                                // width: '92%',
                                                // height: moderateScale(28),
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: Colors.yellow,
                                                borderRadius: moderateScale(6),
                                                marginHorizontal: moderateScale(2),
                                                paddingHorizontal: moderateScale(4),
                                                paddingVertical: moderateScale(2),


                                            }}>

                                            <HMTextView
                                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                text={i18n.t('constant.Update')}
                                                //  text={"ثبت و بستن تیکت"}
                                                type={"bold"}
                                                style={{
                                                    fontSize: moderateScale(10),
                                                    marginVertical: moderateScale(2),
                                                    //     marginHorizontal: moderateScale(4),
                                                    color: Colors.white
                                                }}/>
                                        </TouchableOpacity>

                                    </View>
                                    :

                                    <View
                                        style={{
                                            width: "100%",
                                            flexDirection: 'row',
                                            justifyContent: 'center',
                                            alignItems: 'center',

                                        }}>


                                        <HMTextView
                                            type={"bold"}

                                            style={[
                                                {
                                                    // position: 'absolute',
                                                    //  bottom: 0,
                                                    // height: moderateScale(44),
                                                    // width: '100%',
                                                    textAlign: "center",
                                                    color: Colors.colorDark,
                                                    fontSize: moderateScale(11),
                                                    //  padding: moderateScale(1),

                                                    // backgroundColor: 'rgba(0,0,0,0.25)',
                                                }]}
                                            numberOfLines={2}
                                            text={i18n.t('constant.Update')}
                                        />
                                        <View style={{width: moderateScale(4)}}/>
                                        <ActivityIndicator color={Colors.colorPrimary} size={"small"}/>

                                    </View>
                                }
                            </View>


                    }
                    <ScrollView
                        refreshControl={
                            <RefreshControl refreshing={this.props.DataSplashScreen.isLoadingBackground}
                                            onRefresh={() => this.getDataServerSplash()
                                            }/>
                        }
                    >
                        <View style={{flex: 1,}}>

                            <View style={{width: "100%",}}>

                                {/*                <HMSlider images={typeExport.sliders} autoPlayWithInterval={3000}/>
*/}

                                {/*       <View style={{width: '100%', height:typeExport.WIDTH/1.4}}>
                                    <HMSlider images={results.slider}
                                              autoPlayWithInterval={3000}/>
                                </View>*/}

                                {/*   <Carousel
                                        ref={(c) => { this._carousel = c; }}
                                        data={typeExport.ENTRIES1}
                                        renderItem={this._renderItem}
                                        sliderWidth={typeExport.WIDTH-moderateScale(10)}
                                        itemWidth={moderateScale(100)}
                                        layout={'default'}
                                    />*/}
                                {/*<Carousel
                                        ref={c => this._slider1Ref = c}
                                        data={typeExport.ENTRIES1}
                                        renderItem={this._renderItemWithParallax}
                                        sliderWidth={typeExport.WIDTH}
                                        itemWidth={typeExport.WIDTH - moderateScale(50)}
                                        hasParallaxImages={true}
                                        firstItem={1}
                                        inactiveSlideScale={0.94}
                                        inactiveSlideOpacity={0.7}
                                        // inactiveSlideShift={20}
                                        containerCustomStyle={{
                                            marginTop: 15,
                                            overflow: 'visible' // for custom animations
                                        }}
                                        contentContainerCustomStyle={{paddingVertical: 10}}
                                        loop={true}
                                        loopClonesPerSide={2}
                                        autoplay={true}
                                        autoplayDelay={500}
                                        autoplayInterval={3000}
                                        onSnapToItem={(index) => this.setState({slider1ActiveSlide: index})}
                                    />*/}

                                {
                                    results && results.slider && results.slider.length > 0 ?
                                        <View style={{
                                            width: '100%',

                                            height: (this.state.widthOriginal > 600) ? 500 : (Platform.OS === "web" ? this.state.widthOriginal : typeExport.WIDTH) / 1.6
                                        }}>
                                            <HMSwiper

                                                list={results.slider}
                                                renderItem={() =>
                                                    results.slider.map((itemSwiper, indexSwiper) => {
                                                        return <DynamicContentSlide
                                                            key={indexSwiper + "ii"}
                                                            itemSwiper={itemSwiper}
                                                            indexSwiper={indexSwiper}


                                                            onPress={() => {

                                                                NavigationService.navigateParams("DetailsScreen", {item: JSON.stringify(itemSwiper)})

                                                            }}
                                                        />
                                                    })
                                                }
                                            />
                                        </View>
                                        :
                                        null

                                }

                                {/*   {
                                    results && results.slider && results.slider != null && results.slider.length > 0 ?
                                        <View
                                            style={{
                                                backgroundColor: "#43ee37",
                                                width: '100%',
                                                height: (Platform.OS === "web" ? this.state.widthOriginal : typeExport._WIDTH) / (results.slider_height ? results.slider_height : 1.8),
                                            }}>

                                            <Carousel page

                                                      ref={c => this._slider1Ref = c}
                                                // data={ENTRIES1}
                                                      data={results.slider}
                                                //    data={this.state.entries}
                                                      renderItem={this._renderItemWithParallax}
                                                // inactiveSlideScale={.99}
                                                // sliderWidth={sliderWidth}
                                                // itemWidth={itemWidth}

                                                      inactiveSlideScale={1}
                                                      sliderWidth={Platform.OS === "web" ? this.state.sliderWidth : sliderWidth}
                                                //itemWidth={Platform.OS === "web" ? this.state.itemWidth :itemWidth}
                                                // itemWidth={Platform.OS === "web" ? this.state.itemWidth :itemWidth}
                                                      itemWidth={Platform.OS === "web" ? 580 : itemWidth}

                                                      hasParallaxImages={true}
                                                      firstItem={SLIDER_1_FIRST_ITEM}

                                                      inactiveSlideOpacity={0.7}
                                                // inactiveSlideShift={20}
                                                      containerCustomStyle={styles.slider}
                                                      contentContainerCustomStyle={styles.sliderContentContainer}
                                                       // loop={true}
                                                       // loopClonesPerSide={2}
                                                      autoplay={true}
                                                      autoplayDelay={500}
                                                      autoplayInterval={3000}
                                                      onSnapToItem={(index) => this.setState({slider1ActiveSlide: index})}
                                                      removeClippedSubviews={false}
                                            />

                                            <View style={{height: moderateScale(4)}}/>
                                            <Pagination
                                                dotsLength={results.slider.length}
                                                activeDotIndex={slider1ActiveSlide}
                                                containerStyle={styles.paginationContainer}
                                                //  dotColor={'rgba(255, 255, 255, 0.92)'}
                                                dotColor={Colors.colorSecondPrimary}
                                                dotStyle={styles.paginationDot}
                                                inactiveDotColor={Colors.black}
                                                inactiveDotOpacity={0.4}
                                                inactiveDotScale={0.6}
                                                carouselRef={this._slider1Ref}
                                                tappableDots={!!this._slider1Ref}
                                            />
                                        </View>
                                        :
                                        null
                                }
*/}

                            </View>
                            <HMListDiffSize width={this.state.widthOriginal} card={true} title
                                            _backgroundColorLoading={Colors.transparent} _main
                                            data={results ? results.menus : []}/>
                        </View>
                    </ScrollView>
                    {/*   {1 === 1 ?
                                <HMItemAdvertising
                                    item={{id: '1', image: 'https://simple-ad-exchange.com/images/footer.jpg'}}
                                    onPress={() => {
                                        alert("ookk")
                                    }}/>
                                : null}*/}


                    <DialogUpdateAppCustomize/>

                </KeyboardAvoidingView>


                {/*   <Toast ref="toast"/>*/}
            </View>
        );
    }


    _renderItemWithParallax({item, index}, parallaxProps) {
        let {results} = store.getState().reducerSplashGetAllData;

        return (


            <TouchableOpacity
                onPress={() => {
                    // global.typeCategory=item.type;
                    NavigationService.navigateParams("DetailsScreen", {item: JSON.stringify(item)})
                }}
                style={{
                    width: '100%',
                    height: "100%",
                    position: 'relative',
                    marginHorizontal: moderateScale(4),
                    //  marginBottom:moderateScale(20),
                    //   backgroundColor:index%2===0?'#29ee0f':'#16d8ee',
                    backgroundColor: '#fff',
                    //    borderTopRightRadius:moderateScale(8),
                    borderTopEndRadius: moderateScale(12),
                    borderTopStartRadius: moderateScale(8),

                    alignItems: 'center',
                    justifyContent: 'center',
                    // justifyContent:'center',
                    // alignItems:'center'
                }}
            >
                <HMImageView
                    resizeMode={'contain'}
                    uriComplete={item.images.file}
                    _backgroundColorLoading={Colors.black}
                    styleImage={{
                        //  resizeMode: 'cover',
                        width: "100%",
                        height: "100%",
                        //   backgroundColor: "#ee7e0c",
                        //  borderTopRightRadius:moderateScale(8),
                        borderTopEndRadius: moderateScale(12),
                        borderTopStartRadius: moderateScale(8),
                    }}
                    //  onLoad={this._onLoad}
                    //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                />

                {
                    item.title ?

                        <View
                            style={[
                                {
                                    position: 'absolute',
                                    bottom: 0,
                                    height: moderateScale(50),
                                    // height: typeExport._WIDTH / ((results.slider_height ? results.slider_height : 1.6) * 4),
                                    width: '100%',
                                    color: Colors.white,
                                    padding: moderateScale(3),
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(0,0,0,0.4)',
                                }]}
                        >
                            <HMTextView
                                type={"bold"}

                                style={[
                                    {
                                        // position: 'absolute',
                                        //  bottom: 0,
                                        // height: moderateScale(44),
                                        // width: '100%',
                                        textAlign: "center",
                                        color: Colors.white,
                                        fontSize: moderateScale(11),
                                        //  padding: moderateScale(1),

                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                    }]}
                                numberOfLines={2}
                                text={item.title}
                            />
                        </View>
                        : null
                }
            </TouchableOpacity>

            /*
               {/!* <SliderEntry
                    data={item}
                    even={(index + 1) % 2 === 0}
                    parallax={true}
                    parallaxProps={parallaxProps}
                />*!/}

                */
        );
    }
}

const
    mapStateToProps = state => {
        return {

            token: state.reducerSplashGetAllData.token,
            DataSplashScreen: state.reducerSplashGetAllData,

        };
    };
const
    mapDispatchToProps = dispatch => {
        return {}
    };
export default connect(mapStateToProps, mapDispatchToProps)

(
    MainScreen
)
;


const delayTime = 300;
let container2 = null;

class DynamicContentSlide extends React.Component {
    constructor(props) {
        super(props);
        container2 = this;
    }

    state = {
        isButtonDisplayed: true,
        firstPress: true,
        lastTime: true,
        backClickCount: 0


    };

    render() {
        const {itemSwiper, indexSwiper, onPress, onPressLike} = this.props;
        const {isButtonDisplayed, firstPress, lastTime} = this.state;
        let timer = false;
        return (
            <TouchableOpacity
                onPress={onPress}
                style={{
                    flex: 1, alignItems: "center", justifyContent: "center",

                    marginHorizontal: moderateScale(4),
                    //  marginBottom:moderateScale(20),
                    //   backgroundColor:index%2===0?'#29ee0f':'#16d8ee',
                    backgroundColor: '#000',
                    //    borderTopRightRadius:moderateScale(8),
                    borderTopEndRadius: moderateScale(12),
                    borderTopStartRadius: moderateScale(8),


                }}
            >
                <HMImageView
                    resizeMode={'contain'}
                    uriComplete={itemSwiper.images.file}
                    _backgroundColorLoading={Colors.black}
                    styleImage={{
                        //  resizeMode: 'cover',
                        width: "100%",
                        height: "100%",
                        // backgroundColor: '#000',
                        //  borderTopRightRadius:moderateScale(8),
                        borderTopEndRadius: moderateScale(12),
                        borderTopStartRadius: moderateScale(8),
                    }}
                    //  onLoad={this._onLoad}
                    //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                />

                {
                    itemSwiper.title ?

                        <View
                            style={[
                                {
                                    position: 'absolute',
                                    bottom: 0,
                                    height: moderateScale(50),
                                    // height: typeExport._WIDTH / ((results.slider_height ? results.slider_height : 1.6) * 4),
                                    width: '100%',
                                    color: Colors.white,
                                    padding: moderateScale(3),
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(0,0,0,0.5)',
                                }]}
                        >
                            <HMTextView
                                type={"bold"}

                                style={[
                                    {
                                        // position: 'absolute',
                                        //  bottom: 0,
                                        // height: moderateScale(44),
                                        // width: '100%',
                                        textAlign: "center",
                                        color: Colors.white,
                                        fontSize: moderateScale(13),
                                        //  padding: moderateScale(1),

                                        // backgroundColor: 'rgba(0,0,0,0.25)',
                                    }]}
                                numberOfLines={2}
                                text={itemSwiper.title}
                            />
                        </View>
                        : null
                }
            </TouchableOpacity>);
    }


}
